module.exports = __webpack_public_path__ + "static/media/post-view6p7in.00624642.png";